
export default { name: "hrv-examination" };
